import { EventEmitter } from '@angular/core';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { saveAs as saveAs } from 'file-saver';
export var FileAction;
(function (FileAction) {
    FileAction["ADD"] = "add";
    FileAction["DELETE"] = "delete";
})(FileAction || (FileAction = {}));
var UploadFileComponent = /** @class */ (function () {
    function UploadFileComponent(campaignService, translate, modalService) {
        this.campaignService = campaignService;
        this.translate = translate;
        this.modalService = modalService;
        this.fileChanged = new EventEmitter();
        this.fileRemoved = new EventEmitter();
        this.enableUpload = true;
    }
    UploadFileComponent.prototype.removeFile = function (fileId) {
        if (!this.files) {
            return;
        }
        var match = this.files.find(function (x) { return x.id === fileId; });
        match.action = FileAction.DELETE;
        // this.files = this.files.filter(file => file.id !== fileId);
        // this.fileChanged.emit(this);
    };
    Object.defineProperty(UploadFileComponent.prototype, "availableFiles", {
        get: function () {
            return this.files.filter(function (file) { return file.action !== FileAction.DELETE; });
        },
        enumerable: true,
        configurable: true
    });
    UploadFileComponent.prototype.onMaterialFileSelected = function (evt) {
        var _this = this;
        if (!evt || !evt.target || !evt.target.files) {
            return;
        }
        var fileList = (evt.target.files);
        if (!fileList.length) {
            return;
        }
        var fileToUpload = fileList[0];
        try {
            this.campaignService.validateMaterialUploadFile(fileToUpload);
            // Only upload one file on each select
            var formData = new FormData();
            formData.append('file', fileToUpload);
            // Temporary disable upload
            this.enableUpload = false;
            this.campaignService.uploadFile(formData).subscribe(function (data) {
                data.content = data.diskFileName;
                data.action = FileAction.ADD;
                data.fileSize = fileToUpload.size;
                _this.files.push(data);
                _this.enableUpload = true;
                _this.fileChanged.emit(_this);
            });
        }
        catch (e) {
            this.validationMsg = this.translate.instant(e.message);
            this.modalService.open(this.warningErrorUploadFile, undefined, true);
        }
    };
    UploadFileComponent.prototype.downloadFile = function (fileData) {
        this.campaignService.downloadCampaignMaterials(fileData).subscribe(function (data) {
            if (!data) {
                return;
            }
            else {
                saveAs(data, fileData.name);
            }
        });
    };
    UploadFileComponent.prototype.isLastLine = function (index) {
        var numOfUploadedFile = this.files.length;
        if (numOfUploadedFile % 2 === 0) {
            return index === numOfUploadedFile - 1 || index === numOfUploadedFile - 2;
        }
        else {
            return index === numOfUploadedFile - 1;
        }
    };
    UploadFileComponent.prototype.isOddLine = function (index) {
        return index % 2 !== 0;
    };
    return UploadFileComponent;
}());
export { UploadFileComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/upload-file/upload-file.component.ts.pre-build-optimizer.js